import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { SelectionTileGroup, SelectionTileGroupProps } from '@sato/components';

export const HookFormSelectionTileGroup = (
  props: { name: string } & SelectionTileGroupProps
) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field, fieldState }) => (
        <SelectionTileGroup
          {...props}
          {...field}
          // Keep the field controlled
          value={field.value ?? null}
          error={fieldState.error?.message}
        />
      )}
    />
  );
};
